import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのNotificationロゴアイコン
 */
export function ProductLogoSmallNotification({
  size = 20,
  color = '#646467',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1035 18.5C11.4842 18.5 12.6035 17.3807 12.6035 16H7.60352C7.60352 17.3807 8.7228 18.5 10.1035 18.5Z"
        fill={color}
      />
      <path
        d="M2.60352 14C2.60352 13.4477 3.05123 13 3.60352 13H16.6035C17.1558 13 17.6035 13.4477 17.6035 14C17.6035 14.5523 17.1558 15 16.6035 15H3.60352C3.05123 15 2.60352 14.5523 2.60352 14Z"
        fill={color}
      />
      <path
        d="M4.60352 8C4.60352 5.23858 6.84209 3 9.60352 3H10.6035C13.3649 3 15.6035 5.23858 15.6035 8V14H4.60352V8Z"
        fill={color}
      />
      <path
        d="M8.85352 2.75C8.85352 2.05964 9.41316 1.5 10.1035 1.5C10.7939 1.5 11.3535 2.05964 11.3535 2.75V4H8.85352V2.75Z"
        fill={color}
      />
    </svg>
  );
}
